import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'
import { loadBase44WhenIdle } from '@/api/base44Lazy'

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)

// Base44 SDK arrives after the page has loaded (keeps Base44's visitor analytics working).
loadBase44WhenIdle()
